// weixin-js-sdk应用
// weixin-js-sdk应用
import {
  Albumweixinsignature,
} from '@/request/api.js'
import wx from './wx.js'

export default {
  methods: {
    wx_config () {
      return new Promise((resolve) => {
        if (localStorage.isJsApi && !/true/g.test(localStorage.isJsApi)) {
          resolve({
            updateAppMessageShareData: (event) => event,
            onMenuShareAppMessage: (event) => event,
            updateTimelineShareData: (event) => event,
            onMenuShareTimeline: (event) => event,
          })
        }
        Albumweixinsignature({
          url: window.location.href.split('#')[0], // window.document.location.href,
        }).then((res) => {
          wx.config({
            debug: false,
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名，见附录1
            jsApiList: [
              'updateAppMessageShareData',
              'updateTimelineShareData',
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'uploadImage',
              'previewImage',
              'chooseImage',
              'downloadImage',
              'getLocalImgData',
            ], // 必填，需要使用的 JS 接口列表，所有JS接口列表见附录2
          })
          wx.ready(() => {
            resolve(wx)
          })
          wx.error((err) => {
            console.log(err)
            resolve({
              updateAppMessageShareData: (event) => event,
              onMenuShareAppMessage: (event) => event,
              updateTimelineShareData: (event) => event,
              onMenuShareTimeline: (event) => event,
            })
          })
        })
      })
    },
  },
}
